<script setup lang="ts">
import type { PersonalMessageStatus } from "@anggunpraya-templates/types";

type WishStatus = Exclude<PersonalMessageStatus, "">;

const props = withDefaults(defineProps<{
  status?: PersonalMessageStatus;
  iconMap?: Partial<Record<WishStatus, string>>;
  classMap?: Partial<Record<WishStatus, string>>;
  baseClass?: string;
  iconClass?: string;
}>(), {
  status: "",
  baseClass: "inline-flex size-6 items-center justify-center rounded-full border",
  iconClass: "size-4 shrink-0",
});

const DEFAULT_ICON_MAP: Record<WishStatus, string> = {
  "attending": "i-heroicons-check-circle-solid",
  "not-attending": "i-heroicons-x-circle-solid",
};

const DEFAULT_CLASS_MAP: Record<WishStatus, string> = {
  "attending": "border-emerald-200/80 bg-emerald-50/80 text-emerald-700",
  "not-attending": "border-rose-200/80 bg-rose-50/80 text-rose-700",
};

const DEFAULT_LABEL_MAP: Record<WishStatus, string> = {
  "attending": "Hadir",
  "not-attending": "Tidak Hadir",
};

const resolvedStatus = computed<WishStatus | null>(() => {
  if (!props.status) {
    return null;
  }

  return props.status;
});

const icon = computed(() => {
  if (!resolvedStatus.value) {
    return "";
  }

  return props.iconMap?.[resolvedStatus.value] ?? DEFAULT_ICON_MAP[resolvedStatus.value];
});

const statusClass = computed(() => {
  if (!resolvedStatus.value) {
    return "";
  }

  return props.classMap?.[resolvedStatus.value] ?? DEFAULT_CLASS_MAP[resolvedStatus.value];
});
</script>

<template>
  <span
    v-if="resolvedStatus && icon"
    :class="[baseClass, statusClass]"
    :title="DEFAULT_LABEL_MAP[resolvedStatus]"
    :aria-label="DEFAULT_LABEL_MAP[resolvedStatus]"
  >
    <UIcon
      :name="icon"
      :class="iconClass"
    />
  </span>
</template>
